




















import { Component, Vue, Prop } from 'vue-property-decorator';

import { StepInfo } from '../models/step';

@Component
export default class Stepper extends Vue {
  @Prop({ required: true })
  private steps!: Array<StepInfo | number>;

  @Prop()
  private options?: {
    dots_first: boolean;
    show_title: boolean;
  };

  @Prop({ required: true })
  private currentStep!: number;

  get working_steps(): Array<StepInfo> {
    const firstStep: StepInfo | number = this.steps[0];

    if (typeof firstStep === 'number') {
      return this.steps.map(
        (elm, index) =>
          ({
            identifier: `${index}`,
            title: (this.options?.show_title && `Passo ${index}`) || '',
          } as StepInfo),
      );
    }

    return this.steps as Array<StepInfo>;
  }

  private showDotInfo(step: StepInfo) {
    return this.options?.show_title && step.title;
  }

  private isActive(step: StepInfo): boolean {
    return this.currentStep === this.working_steps.findIndex((elm) => elm.identifier === step.identifier);
  }

  private isCompleted(step: StepInfo | number): boolean {
    const indexStep = this.working_steps.findIndex(
      (elm, index) => (typeof step !== 'number' && elm.identifier === step.identifier) || index === step,
    );
    const indexCurrentStep = this.working_steps.findIndex((elm, index) => index === this.currentStep);

    return indexCurrentStep > indexStep;
  }

  private onLastStep(): boolean {
    return this.currentStep === this.working_steps.length - 1;
  }

  public nextPrev(step: StepInfo | number) {
    if (this.onLastStep() && step === 1) {
      return this.$emit('finish');
    }

    let index: number = this.currentStep;

    if (typeof step === 'number') {
      index += step;
    } else {
      index = this.working_steps.findIndex((elm) => elm.identifier === step.identifier);
    }

    this.$emit('current-step', this.working_steps[index]);
  }
}
